import api from '../api';
import { FIND_RP_URLS } from '../constants/actionTypes';


export const findRpUrls = () => {
    return api.fetch(FIND_RP_URLS, api.config.findRpUrls(), api.http.get())   
};
